"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const injector_1 = require("./injector");
const base_1 = require("../base");
const objectSchemaComponent = (0, injector_1.createObjectSchemaComponent)(() => base_1.Field);
exports.default = objectSchemaComponent;
